export default __webpack_public_path__ + "static/media/T_65_mobile.cfaccf93.jpg";